import coverage from '~/languages/en/press/coverage.js';
import { SOCIAL_ITEMS_FORM } from '~/utils/social.js';

export default {
  title: {
    base: 'Healistic',
    keyword: 'in the press',
  },
  contact: {
    title: {
      base: 'Contact us',
      extra: 'at',
    },
    link: 'hello@healistic.net',
  },
  social: {
    items: SOCIAL_ITEMS_FORM,
    description: 'Follow us on our social media channels',
  },
  coverage,
};
